import React from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Empty, Pagination, Spin } from "antd";
import { getMemberPhone, getMemberRoles } from "../helpers";
import RoleBadges from "./RoleBadges";
import StatusBadge from "./StatusBadge";
import TeamMemberCell from "./TeamMemberCell";

const TeamTable = ({
  loading,
  members,
  totalMembers,
  page,
  pageSize,
  seatSummary,
  onPageChange,
  onEditMember,
}) => {
  if (loading) {
    return (
      <div className="team-page__loading">
        <Spin size="large" />
      </div>
    );
  }

  if (!members.length && !totalMembers) {
    return (
      <div className="team-page__card team-page__empty">
        <Empty description="No team members found" />
      </div>
    );
  }

  return (
    <div className="team-page__card">
      <div className="team-page__mobile-list">
        {members.map((member) => (
          <article
            className="team-page__mobile-card"
            key={`mobile-${member.memberStatus}-${member._id}`}
          >
            <div className="team-page__mobile-card-header">
              <TeamMemberCell member={member} />
              <div className="team-page__actions">
                <button
                  className="team-page__icon-button"
                  onClick={() => onEditMember(member)}
                  type="button"
                >
                  <EditOutlined />
                </button>
                {member.memberStatus !== "Active" ? (
                  <button
                    className="team-page__icon-button team-page__icon-button--danger"
                    disabled
                    type="button"
                  >
                    <DeleteOutlined />
                  </button>
                ) : null}
              </div>
            </div>

            <div className="team-page__mobile-card-grid">
              <div className="team-page__mobile-row">
                <span className="team-page__mobile-label">Role</span>
                <RoleBadges roles={getMemberRoles(member)} />
              </div>
              <div className="team-page__mobile-row">
                <span className="team-page__mobile-label">Mobile Number</span>
                <span className="team-page__phone">{getMemberPhone(member)}</span>
              </div>
              <div className="team-page__mobile-row">
                <span className="team-page__mobile-label">Status</span>
                <StatusBadge status={member.memberStatus} />
              </div>
            </div>
          </article>
        ))}
      </div>
      <div className="team-page__table-wrap">
        <table className="team-page__table">
          <thead>
            <tr>
              <th>Member Name</th>
              <th>Role</th>
              <th>Mobile Number</th>
              <th>Status</th>
              <th className="team-page__action-header">Action</th>
            </tr>
          </thead>
          <tbody>
            {members.map((member) => (
              <tr key={`${member.memberStatus}-${member._id}`}>
                <td>
                  <TeamMemberCell member={member} />
                </td>
                <td>
                  <RoleBadges roles={getMemberRoles(member)} />
                </td>
                <td className="team-page__phone">{getMemberPhone(member)}</td>
                <td>
                  <StatusBadge status={member.memberStatus} />
                </td>
                <td>
                  <div className="team-page__actions">
                    <button
                      className="team-page__icon-button"
                      onClick={() => onEditMember(member)}
                      type="button"
                    >
                      <EditOutlined />
                    </button>
                    {member.memberStatus !== "Active" ? (
                      <button
                        className="team-page__icon-button team-page__icon-button--danger"
                        disabled
                        type="button"
                      >
                        <DeleteOutlined />
                      </button>
                    ) : null}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="team-page__footer">
        <div className="team-page__seat-count">{seatSummary}</div>
        <Pagination
          current={page}
          onChange={onPageChange}
          pageSize={pageSize}
          total={totalMembers}
          showSizeChanger={false}
        />
      </div>
    </div>
  );
};

export default TeamTable;
